import { Component, Input } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ShareToUsersComponent } from '../../../../../../@shared/components/share-to-users/share-to-users.component';
import { ShareContractService } from '../../../../../../contract-management/services/share-contract.service';
import { IShareUser, SHARE_ACCESS, SHARE_FEATURE } from '../../../../../../@core/models/model';
import { ToastService } from '../../../../../../@core/services/toast.service';
import { ButtonComponent } from '../../../../../../@core/components/ui/button/button.component';
import { IconComponent } from '../../../../../../@core/components/ui/icon/icon.component';
import { SVG } from '../../../../../../common/svgs';
import { GeotechnicalAnalysisReport } from '../../../../services/geotechnical-analysis.service';
import { IWorkspace } from '../../../../../../@core/models/model';

@Component({
  selector: 'app-share-report',
  standalone: true,
  imports: [
    DialogModule,
    ShareToUsersComponent,
    ButtonComponent,
    IconComponent,
  ],
  templateUrl: './share-report.component.html',
  styleUrl: './share-report.component.scss'
})
export class ShareReportComponent {

  @Input() analysisReport!: GeotechnicalAnalysisReport;
  @Input() workspace!: string | null;
  @Input() projectId!: string;

  SVG = SVG;
  SHARE_FEATURE = SHARE_FEATURE;

  shareDialog = false;
  shareDetails: { users: IShareUser[]; anyone: SHARE_ACCESS; workspaceShare?: boolean; projectShare?: boolean } = {
    users: [],
    anyone: SHARE_ACCESS.RESTRICTED,
    workspaceShare: false,
    projectShare: false
  };

  isSharedWithWorkspace = false;
  isSharedWithProject = false;

  get workspaceAsObject(): IWorkspace | null {
    return this.workspace ? { _id: this.workspace } as IWorkspace : null;
  }

  constructor(
    private shareService: ShareContractService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.getShareDetails();
  }

  getShareDetails() {
    this.shareService.getShareDetails(this.analysisReport._id, SHARE_FEATURE.GEOTECHNICAL_ANALYSIS).subscribe(res => {
      if (res.success) {
        this.shareDetails = res.data;
        this.shareDetails.workspaceShare = res.data.workspaceShare ? true : false;
        this.shareDetails.projectShare = res.data.projectShare ? true : false;
        this.isSharedWithWorkspace = this.shareDetails.workspaceShare ?? false;
        this.isSharedWithProject = this.shareDetails.projectShare ?? false;
      }
    });
  }

  openShareDialog() {
    this.getShareDetails();
    this.shareDialog = true;
  }

  onCloseShareDialog() {
    this.shareDialog = false;
  }

  toggleShareDialog() {
    this.shareDialog = !this.shareDialog;
  }

  addUserToShare(shareUser: Partial<IShareUser>) {
    this.shareService.addUserToShare(this.analysisReport._id, shareUser, SHARE_FEATURE.GEOTECHNICAL_ANALYSIS).subscribe(res => {
      if (res.success) {
        this.shareDetails = res.data;
        this.shareDetails.workspaceShare = res.data.workspaceShare ? true : false;
        this.shareDetails.projectShare = res.data.projectShare ? true : false;
        this.isSharedWithWorkspace = this.shareDetails.workspaceShare ?? false;
        this.isSharedWithProject = this.shareDetails.projectShare ?? false;
        this.toastService.success('Member added successfully');
      }
    });
  }

  removeUserFromShare(shareUser: Partial<IShareUser>) {
    this.shareService.removeUserFromShare(this.analysisReport._id, shareUser._id as string, SHARE_FEATURE.GEOTECHNICAL_ANALYSIS).subscribe(res => {
      if (res.success) {
        this.toastService.success('Member removed successfully');
        this.getShareDetails();
      }
    });
  }

  refreshShareDetails() {
    this.getShareDetails();
  }

  updateSharedUser(shareUser: IShareUser) {
    this.shareService.updateShareUser(this.analysisReport._id, shareUser, SHARE_FEATURE.GEOTECHNICAL_ANALYSIS).subscribe(res => {
      if (res.success) {
        this.toastService.success('Member updated successfully');
      }
    });
  }

  changeAnyoneAccess(access: SHARE_ACCESS) {
    this.shareService.updateAnyoneAccess(this.analysisReport._id, access).subscribe(res => {
      if (res.success) {
        this.toastService.success('Access updated successfully');
      }
    });
  }

  changeSharedWithWorkspace(value: boolean) {
    if (!this.workspace) return;
    const workspaceShare = value ? this.workspace : null;
    this.shareService.updateShare(this.analysisReport._id, { workspaceShare }, SHARE_FEATURE.GEOTECHNICAL_ANALYSIS).subscribe(res => {
      if (res.success) {
        this.toastService.success('Access updated successfully');
      }
    });
  }

  changeSharedWithProject(value: boolean) {
    const projectShare = value ? this.projectId : null;
    this.shareService.updateShare(this.analysisReport._id, { projectShare }, SHARE_FEATURE.GEOTECHNICAL_ANALYSIS).subscribe(res => {
      if (res.success) {
        this.toastService.success('Access updated successfully');
      }
    });
  }
}
